<template>
  <div style="background-color: #f0f0f0; display: flex; flex-direction: column; gap: 10px; padding: 20px;">
    <h1>OAuth2 JWT Test</h1>
    <button @click="onLogin('naver')">Naver Login</button>
    <button @click="onLogin('kakao')">Kakao Login</button>
    <button @click="testApi">Test API</button>
  </div>
</template>

<script setup>
import axios from 'axios'

// API Base URL
const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;
console.log("API_BASE_URL",API_BASE_URL)
// 로그인 버튼 클릭 시 provider별 리디렉션
const onLogin = (provider) => {
  const loginUrl = `${API_BASE_URL}/oauth2/authorization/${provider}`
  window.location.href = loginUrl
}

// 인증된 사용자 API 호출 테스트
const testApi = () => {
  axios
  .get(`${API_BASE_URL}/`, { withCredentials: true })
  .then(res => {
    alert(JSON.stringify(res.data))
  })
  .catch(error => {
    alert(error)
  })
}
</script>

<style scoped>
button {
  padding: 8px 16px;
  border: none;
  background-color: #0070f3;
  color: white;
  font-weight: bold;
  border-radius: 4px;
  cursor: pointer;
}
button:hover {
  background-color: #005bb5;
}
</style>
